'use client';
import Pagination from '@/components/pagination';
import PoliceLineDivider from '@/components/police-line-divider';
import { ListContainer } from '@/hooks/use-board';
import { ArticleType } from '@/services/types/article.type';
import EventCard from './components/event-card';
import EventHeader from './components/event-header';

// 이벤트
export default function Client() {
  return (
    <ListContainer
      type={ArticleType.EVENT}
      limit={9}
      render={({ items, page, totalPages, onPageChange, headerItem }) => {
        return (
          <>
            {headerItem && <EventHeader {...headerItem} />}

            <div className="desktop:my-20 mt-8 mb-10">
              <PoliceLineDivider />
            </div>

            <div className="desktop:grid desktop:grid-cols-3 desktop:mt-20 desktop:gap-8 mt-10 flex flex-col gap-7">
              {items.map((item) => (
                <EventCard {...item} key={item.id} />
              ))}
            </div>

            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </>
        );
      }}
    />
  );
}
